import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { generateBaseEntity } from 'client/utils/createStructureUtils'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { BorderTypeEnum } from 'common/types/styleTypes'

export const createSearchResults = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): SearchResultsInterface => {
  const entity: SearchResultsInterface = {
    ...generateBaseEntity(
      EntityTypeEnum.SearchResults,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.SearchResults,

    maxItems: 10,

    card: {
      padding: {
        paddingTop: 24,
        paddingRight: 0,
        paddingBottom: 24,
        paddingLeft: 0,
      },
      border: {
        color: 'rgba(229, 231, 235, 1)',
        style: BorderStyleEnum.solid,
        width: 1,
        type: BorderTypeEnum.bottomOnly,
      },
    },

    total: {
      fontSize: 18,
      lineHeight: 22,
      mobileFontSize: 16,
      mobileLineHeight: 24,
      fontWeight: '500',
      color: 'rgba(31, 41, 55, 1)',
      textAlign: 'left',
    },

    title: {
      fontSize: 20,
      lineHeight: 28,
      mobileFontSize: 16,
      mobileLineHeight: 22,
      fontWeight: '700',
      color: 'rgba(31, 41, 55, 1)',
      textAlign: 'left',
      margin: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 15,
        marginLeft: 0,
      },
    },

    text: {
      fontSize: 16,
      lineHeight: 28,
      mobileFontSize: 12,
      mobileLineHeight: 20,
      fontWeight: '400',
      color: 'rgba(31, 41, 55, 1)',
      textAlign: 'left',
      margin: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 32,
        marginLeft: 0,
      },
    },

    date: {
      fontSize: 14,
      lineHeight: 20,
      mobileFontSize: 12,
      mobileLineHeight: 16,
      fontWeight: '600',
      color: 'rgba(107, 114, 128, 1)',
      textAlign: 'left',
    },

    pagination: {
      activeColor: 'rgba(0, 165, 255, 1)',
      activeBackgroundColor: 'rgba(255, 255, 255, 1)',
      inactiveColor: 'rgba(85, 95, 110, 1)',
      inactiveBackgroundColor: 'rgba(228, 232, 238, 1)',
    },
  }

  return entity
}

export const getSearchResultsFontProperties = (
  entity: SearchResultsInterface,
) => {
  const fontProperties = []
  if (entity.title.fontFamily) {
    fontProperties.push({
      fontFamily: entity.title.fontFamily,
      fontStyle: entity.title.fontStyle,
      fontWeight: entity.title.fontWeight,
    })
  }

  if (entity.title.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.title.mobileFontFamily,
      fontStyle: entity.title.mobileFontStyle,
      fontWeight: entity.title.mobileFontWeight,
    })
  }

  if (entity.text.fontFamily) {
    fontProperties.push({
      fontFamily: entity.text.fontFamily,
      fontStyle: entity.text.fontStyle,
      fontWeight: entity.text.fontWeight,
    })
  }

  if (entity.text.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.text.mobileFontFamily,
      fontStyle: entity.text.mobileFontStyle,
      fontWeight: entity.text.mobileFontWeight,
    })
  }

  if (entity.date.fontFamily) {
    fontProperties.push({
      fontFamily: entity.date.fontFamily,
      fontStyle: entity.date.fontStyle,
      fontWeight: entity.date.fontWeight,
    })
  }

  if (entity.date.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.date.mobileFontFamily,
      fontStyle: entity.date.mobileFontStyle,
      fontWeight: entity.date.mobileFontWeight,
    })
  }

  if (entity.total.fontFamily) {
    fontProperties.push({
      fontFamily: entity.total.fontFamily,
      fontStyle: entity.total.fontStyle,
      fontWeight: entity.total.fontWeight,
    })
  }

  if (entity.total.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.total.mobileFontFamily,
      fontStyle: entity.total.mobileFontStyle,
      fontWeight: entity.total.mobileFontWeight,
    })
  }
  return fontProperties
}

export const getSearchResultsCustomFontProperties = (
  entity: SearchResultsInterface,
) => {
  const fontProperties = []

  if (entity.title.fontFamily && entity.title.fontFileId) {
    fontProperties.push({
      fontFamily: entity.title.fontFamily,
      fontFileId: entity.title.fontFileId,
    })
  }
  if (entity.title.mobileFontFamily && entity.title.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.title.mobileFontFamily,
      fontFileId: entity.title.mobileFontFileId,
    })
  }

  if (entity.text.fontFamily && entity.text.fontFileId) {
    fontProperties.push({
      fontFamily: entity.text.fontFamily,
      fontFileId: entity.text.fontFileId,
    })
  }
  if (entity.text.mobileFontFamily && entity.text.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.text.mobileFontFamily,
      fontFileId: entity.text.mobileFontFileId,
    })
  }

  if (entity.date.fontFamily && entity.date.fontFileId) {
    fontProperties.push({
      fontFamily: entity.date.fontFamily,
      fontFileId: entity.date.fontFileId,
    })
  }
  if (entity.date.mobileFontFamily && entity.date.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.date.mobileFontFamily,
      fontFileId: entity.date.mobileFontFileId,
    })
  }

  if (entity.total.fontFamily && entity.total.fontFileId) {
    fontProperties.push({
      fontFamily: entity.total.fontFamily,
      fontFileId: entity.total.fontFileId,
    })
  }
  if (entity.total.mobileFontFamily && entity.total.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.total.mobileFontFamily,
      fontFileId: entity.total.mobileFontFileId,
    })
  }

  return fontProperties
}
